export default "__VITE_ASSET__rG5j9Mft__"